
<template>
    <div class="x-facelist-view" data-automation="faceLibrary">
        <!-- 搜索行 -->
        <div class="search-line">
            <ux-searchOption
              :layout="layout"
              :data="filter"
              @search="search"
              @resetsearch="resetsearch"
            ></ux-searchOption>
            <p class="page-count">{{$t('HT.orderOverview.total', { total: tableData.totalSize })}}</p>
        </div>
        <!-- 人脸库结果列表 -->
        <div v-if="tableData.list.length > 0" class="face-view-list">
          <div class="face-management">
              <div
                class="face-library-item"
                v-for="(item, index) in tableData.list"
                :key="item.id"
                @click="showDrawer(item)">
                  <div class="face-name">{{ item.name }}</div>
                  <div class="face-ID">{{ item.id }}</div>
                  <div class="face-time">{{ item.created_date }}
                      <!-- <i class="ux_icon_arrow_right" @click="showDrawer(item.id)"></i> -->
                      <i class="ux_icon_arrow_right" />
                  </div>
              </div>
          </div>
          <!-- 分页器 -->
          <ux-pagination :total="tableData.totalSize" layout="total, sizes, prev, pager, next" @size-change="changeSize" @current-change="changePage"></ux-pagination>
        </div>
        <!-- 缺省页 -->
        <div v-else class="face-library-nodata">
          <default-graph type="2" :text="$t('HT.faceLibrary.nodate')"></default-graph>
        </div>
        <!-- 人脸库详情 -->
        <el-drawer
            :title="$t('HT.face.librarydetail')"
            :visible.sync="faceDetailVisiable"
            :modal="false"
            custom-class="face-detail"
            direction="rtl"
            size="460px"
            :append-to-body="true">
            <face-detail :appdata="applyData" :group="groupList" :group-arr="groupListArray" />
        </el-drawer>
    </div>
</template>

<script>
import faceDetail from './template/faceDetail';
import Cookies from 'js-cookie'; // cookie插件
import defaultGraph from '@c/defaultGraph/defaultGraph';

export default {
  components: {
    faceDetail,
    defaultGraph
  },
  data() {
    return {
      // userData:{} ,// 登录者信息
      layout: [ // 搜索项配置
        {
          type: 'input',
          key: 'name',
          placeholder: this.$t('HT.face.entername'),
          hideBtn: false
        },
        {
          type: 'button',
          text: this.$t('HT.reset'),
          plain: true,
          event: 'resetsearch'
        }
      ],
      filter: { // 查询参数
        name: '', // 应用名称
        status: true, // 正常
        page: 1,
        size: 10,
      },
      tableData: { // 表格数据
        totalSize: 0,
        list: []
      },
      faceDetailVisiable: false,
      applyData: {},
      groupList: [],
      groupListArray: []
    };
  },
  created() {
    this.getAllList(this.filter);
  },

  methods: {

    /**
         * 获取列表
         * @param {Object} params 请求参数
         */
    getAllList(params) {
      this.$uxLoading.show();
      this.$api.faceRecognition.getList(params).then(res => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },
    /**
     * 重置搜索项
    */
    resetsearch() {
      console.log('重置');
      this.filter.name = '';
      this.search();
    },
    /**
         * 搜索
         */
    search() {
      this.filter.page = 1;
      this.getAllList(this.filter);
    },

    /**
         * 改变页容量
         * @param {Number} size 选择的页容量
         */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getAllList(this.filter);
    },
    /**
         * 改变页码
         * @param {Number} page 选择的页码
         */
    changePage(page) {
      this.filter.page = page;
      this.getAllList(this.filter);
    },
    showDrawer(data) {
      console.log('id', data);
      this.applyData = data;
      this.getGroupList();
      // this.faceDetailVisiable = true;
    },
    // 获取用户组信息
    getGroupList() {
      const lang = Cookies.get('locale') === 'zh' ? 'zh_CN' : 'en_US';
      const params = {
        appKey: this.applyData.app_key,
        appSecret: this.applyData.app_secret,
        ver: 1,
        lang
      };
      this.$api.faceRecognition.getFaceGroupList(params)
        .then(res => {
          if (res.code == 10000) {
            this.groupList = res.data.group_id_list;
            this.groupListArray = [];
            res.data.group_id_list.forEach((item) => {
              this.groupListArray.push({ groupId: item });
            });
            this.faceDetailVisiable = true;
          }
        });
    },
  }
};
</script>

<style lang="scss" scoped>
.x-facelist-view {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
    margin: 0 20px 0px 20px;
    .search-line {
        display: flex;
        justify-content:space-between;
        align-items: center;
        .page-count {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #8690AA;
            line-height: 20px;
        }
    }
    .face-view-list {
      max-height: calc(100% - 200px);
    }
    .face-management {
        max-height: 100%;
        overflow: auto;
        background: #FFFFFF;
        border-radius: 8px;
        padding: 20px 0 0 20px;
        margin-bottom: 84px;
        .face-library-item {
            padding: 24px 20px;
            box-sizing: border-box;
            display: inline-block;
            margin: 0 20px 20px 0;
            background: #FFFFFF;
            border-radius: 8px;
            border: 1px solid #E8ECF2;
            width: calc(25% - 22px);
            height: 128px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #5A6482;
            line-height: 20px;
            cursor: pointer;
            .face-name {
                font-size: 14px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #161E28;
                line-height: 20px;
            }
            .face-ID {
                margin: 10px 0;
            }
            .face-time {
                display: flex;
                align-items: center;
                justify-content: space-between;
                >i {
                    cursor: pointer;
                }
            }
        }
    }
    .face-library-nodata {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
}

.x-facelist-view ::v-deep .ux-pagination {
    padding: 0;
    position: absolute;
    right: 0;
    bottom: 32px;
}

.el-drawer__wrapper {
  z-index: 1000 !important;
}
::v-deep .face-detail {
    padding: 32px 20px 24px;
    .el-drawer__header {
        border-bottom: 1px solid #E8ECF2;
        padding: 0 0 13px 0;
        margin-bottom: 20px;
        span {
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #161E28;
            line-height: 26px;
        }
    }
    .el-drawer__body {
      height: 100%;
    }
}
</style>
